var logUsageOb;
var logErrorOb;

export function flog(log) {
    let str = "";
    let d = new Date().toISOString();
    str += "[" + d + "] ";
    str += log;
    // console.log(">>>>FLOG<<<<-", str);
    writeUsageLog(`${str} \n`);
}

export function flogError(log) {
    let str = "";
    let d = new Date().toISOString();
    str += "[" + d + "] ";
    str += log;
    // console.log(">>>>ERROR LOG<<<<-", str);
    writeErrorLog(`${str} \n`);
}

function startWriteUsageLog() {
    let nome = new Date().toISOString().split("T")[0];

    nome = "LOG_" + nome + ".txt";

    let folderPath = window.cordova.file.externalDataDirectory;

    // console.log("folderPath", folderPath);
    // console.log("nome", nome);

    window.resolveLocalFileSystemURL(folderPath, function (dir) {
        // console.log("got main dir", dir);
        dir.getFile(nome, { create: true }, function (file) {
            // console.log("got the file", file);
            logUsageOb = file;
            writeUsageLog("App started \n");
        });
    });
}

function writeUsageLog(log) {
    if (window.cordova) {
        if (window.cordova.platformId === `ios`) {

        } else {

            if (!logUsageOb) {
                startWriteUsageLog();
            } else {
                logUsageOb.createWriter(
                    function (fileWriter) {
                        fileWriter.seek(fileWriter.length);

                        var blob = new Blob([log], { type: "text/plain" });
                        fileWriter.write(blob);
                        // console.log("ok, in theory i worked");
                    },
                    (err) => console.log("err ao salvar", err)
                );
            }
        }
    }
}

export function writeJson(folder, filename, json) {
    if (window.cordova) {
        let nome = filename + ".json";

        let folderPath = window.cordova.file.externalDataDirectory;

        // console.log('nome', nome)
        let mesPasta = new Date().toISOString().slice(0, 7);
        // console.log('mesPasta', mesPasta)
        window.resolveLocalFileSystemURL(folderPath, function (dir) {
            // console.log("got main dir", dir);

            dir.getDirectory("bkp-json", { create: true }, (dir2) => {
                dir2.getDirectory(mesPasta, { create: true }, (dir3) => {
                    dir3.getDirectory(folder, { create: true }, (dirEntry) => {
                        // console.log('dirEntry', dirEntry)
                        dirEntry.getFile(nome, { create: true }, function (file) {
                            // console.log("got the file", file);

                            file.createWriter(
                                function (fileWriter) {
                                    fileWriter.seek(fileWriter.length);
                                    let jsonStr = JSON.stringify(json);
                                    var blob = new Blob([jsonStr], { type: "text/plain" });
                                    fileWriter.write(blob);
                                    // console.log("ok, in theory i worked", nome);
                                },
                                (err) => console.log("err ao salvar", err)
                            );
                        });
                    });
                });
            });
        });
    }
}

function startWriteErrorLog() {
    let nome = new Date().toISOString().split("T")[0];

    nome = "ERROR_LOG_" + nome + ".txt";

    let folderPath = window.cordova.file.externalDataDirectory;

    window.resolveLocalFileSystemURL(folderPath, function (dir) {
        console.log("got main dir", dir);
        dir.getFile(nome, { create: true }, function (file) {
            console.log("got the file", file);
            logErrorOb = file;
            writeErrorLog("App started \n");
        });
    });
}

function writeErrorLog(log) {
    if (window.cordova) {
        if (!logErrorOb) {
            startWriteErrorLog();
        } else {
            logErrorOb.createWriter(
                function (fileWriter) {
                    fileWriter.seek(fileWriter.length);

                    var blob = new Blob([log], { type: "text/plain" });
                    fileWriter.write(blob);
                    console.log("Error log working");
                },
                (err) => console.log("err ao salvar log de erro", err)
            );
        }
    }
}
